<div class="menu">
	<header>
		<img src="assets/images/CoRD.svg" alt="" />
	</header>
	<div class="menu-scroll">
		
		<div class="option-wrapper" *ngFor="let feature of features">

			<div
			  class="option"
			  [ngClass]="{
				active: page == feature.className,
				expandable: feature.children
			  }"
			  (click)="feature.children ? toggleMenu(feature) : null"
			  [routerLink]="!feature.children ? [feature.route] : null"
			>
			  <i class="fa" [ngClass]="feature.icon"></i>
			  <span>{{ feature.name }}</span>
		  
			  <i
				*ngIf="feature.children"
				class="fa fa-chevron-down arrow"
				[ngClass]="{ open: openMenu === feature.className }"
			  ></i>
			</div>
		  
			<div class="submenu" *ngIf="feature.children && openMenu === feature.className">
			  <div
				class="option sub-option"
				*ngFor="let child of feature.children"
				[routerLink]="[child.route]"
				[ngClass]="{ active: page == child.className }"
			  >
				<i class="fa" [ngClass]="child.icon"></i>
				<span>{{ child.name }}</span>
			  </div>
			</div>
		  
		  </div>
		  
		<div class="option" [ngClass]="{ active: page == 'addresses' }" [routerLink]="['/members/addresses']"
			*ngIf="isMerkaoUser">
			<i class="fa fa-map-pin"></i>
			<span>Cambiar direcciones</span>
		</div>
		<div class="option" [ngClass]="{ active: page == 'users-block' }" [routerLink]="['/members/users-block']"
			*ngIf="isMerkaoUser">
			<i class="fa fa-lock"></i>
			<span>Bloquear Usuarios</span>
		</div>
		<div class="option" (click)="logout()">
			<i class="fa fa-sign-out"></i>
			<span>Salir</span>
		</div>
	</div>
	<div class="info" *ngIf="user">
		<h4><i class="fa fa-user"></i> {{ user.name }}</h4>
		<h4 *ngIf="user.storeName" [ngClass]="isAdmin && !user.subsidiaryName ? 'admin' : ''" (click)="removeStore()">
			<i class="fa fa-area-chart"></i> {{ isAdmin && !user.subsidiaryId ? user.storeName + ' (salir)' :
			user.storeName }}
		</h4>
		<h4 *ngIf="user.subsidiaryName" [ngClass]="isAdmin || isManager ? 'admin' : ''" (click)="removeSubsidiary()">
			<i class="fa fa-shopping-basket"></i> {{ isAdmin || isManager ? user.subsidiaryName + ' (salir)' :
			user.subsidiaryName }}
		</h4>
		<h5>&#64;Beta 1.89.0</h5>
	</div>
</div>